/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { MarkupPanelOverlayRef } from './markup-panel-overlay-ref';
import { MapInteractionsService } from '../../../services/mapInteractions.service';
import { MatDialog } from '@angular/material/dialog';
import { MarkupTextDialogComponent } from './markup-text-dialog.component';
import { DialogRef } from '@angular/cdk/dialog';
import { FlexiblePanelComponent } from '../../../../../core/ui/flexible-panel/flexible-panel.component';
import {
    LayoutDirective,
    LayoutGapDirective,
    LayoutAlignDirective,
} from '@ngbracket/ngx-layout/flex';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { ClassDirective } from '@ngbracket/ngx-layout';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'dash-gis-markup-panel',
    templateUrl: './markup-dialog.component.html',
    styleUrls: ['./markup-dialog.component.scss'],
    imports: [
        FlexiblePanelComponent,
        LayoutDirective,
        LayoutGapDirective,
        LayoutAlignDirective,
        MatIconButton,
        MatTooltip,
        NgClass,
        ClassDirective,
        MatIcon,
        FormsModule,
        MatButton,
    ],
})
export class MarkupDialogComponent implements OnInit {
    private _color: string;
    private _tool: string;

    /**
     * @param dialogRef {DialogRef}
     * @param dialog
     * @param mapInteractions
     */
    constructor(
        private dialogRef: DialogRef,
        private dialog: MatDialog,
        private mapInteractions: MapInteractionsService
    ) {
        this._color = '#ff0000';
        this._tool = '';
    }

    public ngOnInit() {}

    public clear() {
        this.mapInteractions.clearMarkup();
    }

    public undo() {
        this.mapInteractions.undoMarkup();
    }

    public close() {
        this.mapInteractions.enablePanInteraction();
        this.dialogRef.close();
    }

    public setTool(tool) {
        this._tool = tool;
        this.mapInteractions.removeInteractions();
        this.mapInteractions.enableMarkup(this.markupTool, this.markupColor, null);
    }

    public getMarkupText() {
        const promptRef = this.dialog.open(MarkupTextDialogComponent);
        promptRef.afterClosed().subscribe((markupText) => {
            if (markupText) {
                this.markupTool = 'text';
                this.mapInteractions.enableMarkup(this.markupTool, this.markupColor, markupText);
            }
        });
    }

    public onColorSelected(color) {
        this.markupColor = color;
    }

    get markupTool() {
        return this._tool;
    }

    set markupTool(tool) {
        this._tool = tool;
    }

    get markupColor() {
        return this._color;
    }

    set markupColor(color) {
        this._color = color;
        if (this._tool) {
            this.mapInteractions.enableMarkup(this.markupTool, this.markupColor, null);
        }
    }

    get hasFeatures() {
        return this.mapInteractions.hasMarkupFeatures;
    }
}
